import { render, staticRenderFns } from "./AuctionCreateForm.vue?vue&type=template&id=55578bfa"
import script from "./AuctionCreateForm.vue?vue&type=script&lang=js"
export * from "./AuctionCreateForm.vue?vue&type=script&lang=js"
import style0 from "./AuctionCreateForm.vue?vue&type=style&index=0&id=55578bfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports